import React from "react";
import { Navigation } from "lucide-react";

/**
 * MapNavButton — tap-to-navigate button that opens Google Maps directions to a
 * destination. Prefers precise lat/lng coords; falls back to a text address.
 * Renders nothing if neither is available.
 */
export const buildMapsUrl = ({ lat, lng, address }) => {
  const hasCoords =
    lat !== undefined && lat !== null && lat !== "" &&
    lng !== undefined && lng !== null && lng !== "" &&
    !(Number(lat) === 0 && Number(lng) === 0);
  if (hasCoords) {
    return `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
  }
  if (address && String(address).trim()) {
    return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(String(address).trim())}`;
  }
  return null;
};

const MapNavButton = ({ lat, lng, address, label = "Navigate", compact = false, className = "", testId }) => {
  const url = buildMapsUrl({ lat, lng, address });
  if (!url) return null;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      data-testid={testId}
      title="Open navigation in Google Maps"
      className={
        compact
          ? `inline-flex items-center justify-center p-1.5 rounded-lg bg-[#E83E8C]/10 text-[#E83E8C] hover:bg-[#E83E8C]/20 transition-colors ${className}`
          : `inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-[#E83E8C]/10 text-[#E83E8C] text-xs font-semibold hover:bg-[#E83E8C]/20 transition-colors ${className}`
      }
    >
      <Navigation size={compact ? 13 : 14} />
      {!compact && <span>{label}</span>}
    </a>
  );
};

export default MapNavButton;
